import {
    Box,
    Flex,
    Heading,
    Modal,
    Paragraph,
    Text as PText,
    Image,
    List,
    ListItem,
    Link
} from '@cof/plastic-components';
import { styled, css } from 'styled-components';
import ModalLink from '../../components/ModalLink/index';

import { withText } from '../../text/textStore';
import PropTypes from 'prop-types';
import { useState } from 'react';
import asosCrownImage from './assets/ASOSCrown.png';
import asosCardImage from './assets/ASOSCard.png';

export const SectionHeading = (props: any) => <Heading level="3" textAlign="left" {...props} />;
SectionHeading.displayName = 'SectionHeading';

export const ModalParagraphDivider = styled.div`
    ${({ theme }: any) => css`
        margin: ${theme.space.md} 0;
        border: solid 0.1rem ${theme.colors.global.grey50};

        ${theme.breakpoints.mq.tabletMin} {
            margin-top: ${theme.space.lg};
        }
    `};
`;
ModalParagraphDivider.displayName = 'ModalParagraphDivider';

export const ModalParagraph = (props: any) => <Paragraph size="small" mt="xs" p="0" {...props} />;
ModalParagraph.displayName = 'ModalParagraph';

export const InternalModalLink = (props: any) => <Link external size="small" {...props} />;
InternalModalLink.displayName = 'ModalLink';

const InnerBox = styled(Box)`
    ${({ theme }: any) => css`
        border-radius: 0.75rem;
        width: 100%;
        align-items: left;
        background-color: ${theme.colors.global.black};
    `}
`;

const GradientBox = styled(Box)`
    ${({ theme }: any) => css`
        border-radius: 0.75rem;
        width: 100%;
        background-image: linear-gradient(to left, ${theme.colors.ASOS.purple350}, ${theme.colors.ASOS.red600});
        overflow: hidden;
    `}
`;

const PremierBanner = ({ Text, Text: text, JsxText }: any) => {
    const [isTermsModalOpen, setTermsModalOpen] = useState(false);

    const PremierHeader = () => (
        <Flex flexWrap="wrap" data-qa-id="premier-banner">
            <Box width={[1, null, '38%']} maxWidth={[1, null, '38%']}>
                <Heading
                    color="global.white"
                    // @ts-expect-error TS2322: Type '"400"' is not assignable to type 'ResponsiveValue<keyof FontWeightKeys, DefaultTheme> | undefi
                    fontWeight="400"
                    data-qa-id="premier-heading-1"
                    // @ts-expect-error TS2322: Type '(string | null)[]' is not assignable to type 'ValidHeadingSizes | undefined'.
                    size={['medium', null, 'small']}
                    textAlign="left"
                    data-qm-allow
                >
                    <Text path="Heading1" params={{ 'data-qm-allow': 'true' }} />
                </Heading>
            </Box>
            <Box flexGrow={1}>
                <Flex marginTop={['-10px', null, '0px']}>
                    <Box width={['80%', null, '64%']} maxWidth="194px">
                        <Heading
                            color="global.white"
                            // @ts-expect-error TS2322: Type '"400"' is not assignable to type 'ResponsiveValue<keyof FontWeightKeys, DefaultTheme> | undefi
                            fontWeight="400"
                            data-qa-id="premier-heading-2"
                            // @ts-expect-error TS2322: Type '(string | null)[]' is not assignable to type 'ValidHeadingSizes | undefined'.
                            size={['medium', null, 'small']}
                            textAlign="left"
                            data-qm-allow
                            paddingBottom="0.8rem"
                        >
                            <Text path="Heading2" params={{ 'data-qm-allow': 'true' }} />
                        </Heading>
                    </Box>
                    <Box width={['10%', null, '20%']}>
                        <Image
                            src={asosCrownImage}
                            width="24px"
                            height="23px"
                            marginLeft={['-16px', null, '-14px']}
                            marginTop={['-7px', null, '-8px']}
                        />
                    </Box>
                </Flex>
            </Box>
        </Flex>
    );

    const TermsModalContent = () => (
        <div data-qa-id="premier-terms-modal-content">
            <Heading level="2" textAlign="left" data-qm-allow>
                {text({ path: 'Terms.Heading' })}
            </Heading>
            <SectionHeading data-qa-id="premier-promoter-header" data-qm-allow>
                {text({ path: 'Terms.Section1.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="premier-promoter-paragraph" data-qm-allow>
                <JsxText
                    path="Terms.Section1.Paragraph1"
                    params={{
                        ASOS_BOLD: (
                            // @ts-expect-error TS2322: Type '"bold"' is not assignable to type 'ResponsiveValue<"regular" | "medium" | "semiBold", DefaultT
                            <PText fontWeight="bold" data-qm-allow>
                                ASOS
                            </PText>
                        ),

                        CAPITAL_ONE_BOLD: (
                            // @ts-expect-error TS2322: Type '"bold"' is not assignable to type 'ResponsiveValue<"regular" | "medium" | "semiBold", DefaultT
                            <PText fontWeight="bold" data-qm-allow>
                                Capital One
                            </PText>
                        )
                    }}
                />
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="premier-partner-header" data-qm-allow>
                {text({ path: 'Terms.Section2.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="premier-partner-paragraph" data-qm-allow>
                <JsxText
                    path="Terms.Section2.Paragraph1"
                    params={{
                        ASOS_BOLD: (
                            // @ts-expect-error TS2322: Type '"bold"' is not assignable to type 'ResponsiveValue<"regular" | "medium" | "semiBold", DefaultT
                            <PText fontWeight="bold" data-qm-allow>
                                ASOS
                            </PText>
                        )
                    }}
                />
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="premier-eligibility-header" data-qm-allow>
                {text({ path: 'Terms.Section3.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="premier-eligibility-paragraph" data-qm-allow>
                {text({ path: 'Terms.Section3.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="premier-promotion-period-header" data-qm-allow>
                {text({ path: 'Terms.Section4.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="premier-promotion-period-paragraph" data-qm-allow>
                <JsxText
                    path="Terms.Section4.Paragraph1"
                    params={{
                        PROMOTION_PERIOD_BOLD: (
                            // @ts-expect-error TS2322: Type '"bold"' is not assignable to type 'ResponsiveValue<"regular" | "medium" | "semiBold", DefaultT
                            <PText fontWeight="bold" data-qm-allow>
                                Promotion Period
                            </PText>
                        )
                    }}
                />
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="premier-offer-header" data-qm-allow>
                {text({ path: 'Terms.Section5.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="premier-offer-paragraph" data-qm-allow>
                <JsxText
                    path="Terms.Section5.Paragraph1"
                    params={{
                        OFFER_BOLD: (
                            // @ts-expect-error TS2322: Type '"bold"' is not assignable to type 'ResponsiveValue<"regular" | "medium" | "semiBold", DefaultT
                            <PText fontWeight="bold" data-qm-allow>
                                Offer
                            </PText>
                        )
                    }}
                />
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="premier-duration-header" data-qm-allow>
                {text({ path: 'Terms.Section6.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="premier-duration-paragraph" data-qm-allow>
                <JsxText
                    path="Terms.Section6.Paragraph1"
                    params={{
                        ASOS_LINK: (
                            <InternalModalLink href={text({ path: 'Terms.Section6.AsosLink' })} data-qm-allow>
                                asos.com
                            </InternalModalLink>
                        )
                    }}
                />
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="premier-how-to-claim-header" data-qm-allow>
                {text({ path: 'Terms.Section7.Heading' })}
            </SectionHeading>
            <List data-qa-id="premier-how-to-claim-list">
                <ListItem data-qa-id="premier-how-to-claim-list-item1" data-qm-allow>
                    {text({ path: 'Terms.Section7.List.Item1' })}
                </ListItem>
                <ListItem data-qa-id="premier-how-to-claim-list-item2" data-qm-allow>
                    {text({ path: 'Terms.Section7.List.Item2' })}
                </ListItem>
                <ListItem data-qa-id="premier-how-to-claim-list-item3" data-qm-allow>
                    {text({ path: 'Terms.Section7.List.Item3' })}
                </ListItem>
                <ListItem data-qa-id="premier-how-to-claim-list-item4" data-qm-allow>
                    {text({ path: 'Terms.Section7.List.Item4' })}
                </ListItem>
            </List>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="premier-code-validity-header" data-qm-allow>
                {text({ path: 'Terms.Section8.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="premier-code-validity-paragraph" data-qm-allow>
                {text({ path: 'Terms.Section8.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="premier-restrictions-header" data-qm-allow>
                {text({ path: 'Terms.Section9.Heading' })}
            </SectionHeading>
            <List data-qa-id="premier-restrictions-list">
                <ListItem data-qa-id="premier-restrictions-list-item1" data-qm-allow>
                    {text({ path: 'Terms.Section9.List.Item1' })}
                </ListItem>
                <ListItem data-qa-id="premier-restrictions-list-item2" data-qm-allow>
                    {text({ path: 'Terms.Section9.List.Item2' })}
                </ListItem>
                <ListItem data-qa-id="premier-restrictions-list-item3" data-qm-allow>
                    {text({ path: 'Terms.Section9.List.Item3' })}
                </ListItem>
                <ListItem data-qa-id="premier-restrictions-list-item4" data-qm-allow>
                    {text({ path: 'Terms.Section9.List.Item4' })}
                </ListItem>
            </List>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="premier-terms-header" data-qm-allow>
                {text({ path: 'Terms.Section10.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="premier-terms-paragraph" data-qm-allow>
                <JsxText
                    path="Terms.Section10.Paragraph1"
                    params={{
                        ASOS_PREMIER_TERMS_LINK: (
                            <InternalModalLink
                                href={text({ path: 'Terms.Section10.AsosPremierTermsLink' })}
                                data-qm-allow
                            >
                                ASOS Premier terms and conditions
                            </InternalModalLink>
                        )
                    }}
                />
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="existing-asos-premier-header" data-qm-allow>
                {text({ path: 'Terms.Section11.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="existing-asos-premier-paragraph" data-qm-allow>
                {text({ path: 'Terms.Section11.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="premier-asos-world-header" data-qm-allow>
                {text({ path: 'Terms.Section12.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="premier-asos-world-paragraph" data-qm-allow>
                <JsxText
                    path="Terms.Section12.Paragraph1"
                    params={{
                        ASOS_TERMS: (
                            <InternalModalLink href={text({ path: 'Terms.Section12.AsosLink' })} data-qm-allow>
                                terms and conditions
                            </InternalModalLink>
                        ),
                        ASOS_CUSTOMER_CARE: (
                            <InternalModalLink
                                href={text({ path: 'Terms.Section12.AsosCustomerCareLink' })}
                                data-qm-allow
                            >
                                Customer Care
                            </InternalModalLink>
                        ),
                        ASOS_WORLD: (
                            <InternalModalLink href={text({ path: 'Terms.Section12.AsosWorldLink' })} data-qm-allow>
                                here
                            </InternalModalLink>
                        )
                    }}
                />
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="premier-data-protection-header" data-qm-allow>
                {text({ path: 'Terms.Section13.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="premier-data-protection-paragraph" data-qm-allow>
                <JsxText
                    path="Terms.Section13.Paragraph1"
                    params={{
                        ASOS_PRIVACY_POLICY: (
                            <InternalModalLink
                                href={text({ path: 'Terms.Section13.AsosPrivacyPolicyLink' })}
                                data-qm-allow
                            >
                                (https://www.asos.com/privacy-policy/)
                            </InternalModalLink>
                        ),
                        CAPITAL_ONE_PRIVACY_POLICY: (
                            <InternalModalLink
                                href={text({ path: 'Terms.Section13.CapitalOnePrivacyPolicyLink' })}
                                data-qm-allow
                            >
                                (https://www.capitalone.co.uk/compliance/privacy-policy/)
                            </InternalModalLink>
                        )
                    }}
                />
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="premier-liability-header" data-qm-allow>
                {text({ path: 'Terms.Section14.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="premier-liability-paragraph" data-qm-allow>
                {text({ path: 'Terms.Section14.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="premier-general-header" data-qm-allow>
                {text({ path: 'Terms.Section15.Heading' })}
            </SectionHeading>
            <List data-qa-id="premier-general-list">
                <ListItem data-qa-id="premier-general-list-item1" data-qm-allow>
                    {text({ path: 'Terms.Section15.List.Item1' })}
                </ListItem>
                <ListItem data-qa-id="premier-general-list-item2" data-qm-allow>
                    {text({ path: 'Terms.Section15.List.Item2' })}
                </ListItem>
                <ListItem data-qa-id="premier-general-list-item3" data-qm-allow>
                    {text({ path: 'Terms.Section15.List.Item3' })}
                </ListItem>
            </List>
            <ModalParagraphDivider />
        </div>
    );

    return (
        <Flex data-qa-id="premier-flex">
            <GradientBox height={['257px', null, '199px']}>
                <InnerBox padding={['1.6rem', null, '2.4rem']} height={['250px', null, '192px']}>
                    <Flex>
                        <Box width={['78%', null, '77%']}>
                            <PremierHeader />
                            {/* @ts-expect-error TS2322: Type '"400"' is not assignable to type 'ResponsiveValue<"regular" | "medium" | "semiBold", DefaultTh */}
                            <Paragraph variant="light" fontWeight="400" data-qm-allow>
                                <PText data-qm-allow color="global.white">
                                    <JsxText path="BodyText" />
                                </PText>{' '}
                                {/* @ts-expect-error TS2322: Type ' children: Element; fontWeight: string; variant: string; onClick: () => void; "data-qa-id": st */}
                                <ModalLink
                                    fontWeight="500"
                                    variant={'light'}
                                    onClick={() => setTermsModalOpen(true)}
                                    data-qa-id="premier-terms-link"
                                    data-qm-allow
                                >
                                    <Text path="Link1.Text" params={{ 'data-qm-allow': 'true' }} />
                                </ModalLink>
                                {'.'}
                            </Paragraph>
                            {/* @ts-expect-error TS2322: Type '"300"' is not assignable to type 'ResponsiveValue<"regular" | "medium" | "semiBold", DefaultTh */}
                            <PText fontWeight="300" color="global.white" data-qm-allow>
                                {/* @ts-expect-error TS2322: Type '"bold"' is not assignable to type 'ResponsiveValue<"regular" | "medium" | "semiBold", DefaultT */}
                                <PText fontWeight="bold" color="global.white" data-qm-allow>
                                    <JsxText path="Apr" />
                                </PText>{' '}
                                <JsxText path="AprSuffix" />
                            </PText>
                        </Box>
                        <Box position="relative">
                            <Image
                                src={asosCardImage}
                                position="absolute"
                                height="270px"
                                width="200px"
                                marginLeft={['-38px', null, '-19px']}
                                marginTop={['-94px', null, '-93px']}
                            />
                        </Box>
                    </Flex>
                </InnerBox>
            </GradientBox>
            <Modal
                rootId={'root'}
                aria-modal="true"
                data-qa-id="premier-terms-modal"
                onClose={() => setTermsModalOpen(false)}
                isOpen={isTermsModalOpen}
                modalWrapperProps={{
                    width: '95%',
                    // @ts-expect-error TS2353: Object literal may only specify known properties, and 'margin' does not exist in type 'WidthProps<Re
                    margin: '0.8rem'
                }}
            >
                <TermsModalContent />
            </Modal>
        </Flex>
    );
};

PremierBanner.propTypes = {
    Text: PropTypes.func.isRequired,
    TemplateText: PropTypes.func,
    JsxText: PropTypes.func.isRequired
};

const PremierBannerWithText = withText('PremierBanner')(PremierBanner);
PremierBannerWithText.displayName = 'PremierBanner';

export default PremierBannerWithText;
